import React from 'react'


function Chair(props) {
  return (
    <div>
        <img src={props.img} alt='Chair'  />
    </div>
  )
}

export default Chair